/**
 * Created with IntelliJ IDEA.
 * User: talf
 * Date: 7/1/13
 * Time: 2:30 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');
    var TableViewController = require('web-agent-framework/TableViewController');
    var ChatViewController = require('web-agent-viewControllers/ChatViewController');
    var App = window.App || {};
    var VisitorInfoViewController = require('web-agent-viewControllers/VisitorInfoViewController');

    var ChatHistoryWidget = WidgetViewController.extend({
        ControllerName: 'ChatHistoryWidget',
        applicationType: 'ChatHistoryWidget',

        LPViewMap: {
            historyItemsContainer: '.lpview_history_items_container',
            pastEngagementsNo: '.lpview_engagements_no',
            pastEngagementTitleText: '.lpview_engagements_title_text',
            mainContainer: '.lpview_chat_history_container',
            errorMessage: '.lpview_error_message',
            historyItem: '.lpview_history_item',
            historyItemTitle: '.lpview_history_item_title',
            rowsPlaceholder: '.lpview_rows_placeholder',
            rowDataContainer: '.lpview_row_data_container',
            visitorInfoButton: '.lpview_visitor_info',
            transcriptButton: '.lpview_transcript',
            retryButton: '.lpview_retry_button',
            cSatItemPlaceholder: '.lpview_history_item_csat',
            csatPlaceholder: '.lpview_engagements_csat_placeholder',
            cSatAverageText: '.lpview_engagements_csat_avg'
        },

        LPClassesMap: {
            loading: 'loading',
            empty: 'empty',
            error: 'error',
            opened: 'opened',
            selected: 'selected',
            asyncMessaging: 'asyncMessaging'
        },

        initialize: function (constructorData) {
            this.onDispose(this.visitorDisposed, this);
            this.chatHistoryDataPath = constructorData.dataPath;
            this.chatHistoryStatePath = constructorData.statePath;

            /**
             * we don't need to wait for the server session info, there is no server session info.
             */
            if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.visitorId)) {
                this.initAsyncMessaging();
            }
        },

        events: function () {
            this.bindVisitorId();
        },

        render: function () {
        }
    });

    ChatHistoryWidget.prototype.initAsyncMessaging = function () {
        // adding the 'messaging' css marker to decorate the widget.
        this.addClass(this.view, this.LPClassesMap.asyncMessaging);

        this.setChatHistoryLoading();
        this.createChatHistoryTable();
        this.getWidgetData();
    };

    ChatHistoryWidget.prototype.getWidgetData = function (reload) {
        this.modelController.getChatHistory({
            visitorId: this.visitorId,
            reload: reload
        });
    };

    ChatHistoryWidget.prototype.updateChatData = function (data) {
        var chatId = lpUtils.getFirstValue(data.newValue);
        this.updateChatId(chatId);
        this.setChatHistoryLoading();
        this.createChatHistoryTable();
    };

    ChatHistoryWidget.prototype.updateChatId = function (chatId) {
        if (chatId && this.chatId !== chatId) {//Split session support
            this.chatId = chatId;
        }
    };

    ChatHistoryWidget.prototype.setChatHistoryLoading = function () {
        this.addClass(this.LPViewMap.mainContainer, this.LPClassesMap.loading);
        this.removeClass(this.LPViewMap.mainContainer, this.LPClassesMap.error);
        var that = this;
        if (!this.loadingTimeout) {
            this.loadingTimeout = setTimeout(function () {
                that.showErrorState(that.translate('chatHistoryError'));
                that.lpShow(that.LPViewMap.retryButton);
            }, 60000);
        }
    };

    ChatHistoryWidget.prototype.bindVisitorId = function () {
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
        var isAsyncMessaging = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.visitorId);
        if (!isAsyncMessaging) {
            this.bindModel({
                modelPath: participantPath + '.participantInfo.visitSessionKey',
                callback: this.handleVisitSessionKeyChanged
            });
            this.bindModel({
                modelPath: participantPath + '.participantInfo.acceptedEngagement',
                callback: this.handleAcceptedEngagementChanged
            });
            this.bindModel({
                modelPath: participantPath + '.participantInfo.spectatedEngagement',
                callback: this.handleSpectatedEngagementChanged
            });
            this.bindModel({
                modelPath: participantPath + '.participantState.engagementState',
                callback: this.handleEngagementStateChanged
            });
            this.bindModel({
                modelPath: participantPath + '.chats', callback: this.updateChatData
            });
        }
        this.bindModel({
            modelPath: participantPath + '.participantTag', callback: this.handleParticipantTag
        });
        this.bindModel({
            modelPath: this.chatHistoryStatePath, callback: this.handleChatHistory
        });
        this.bindViewEvent({
            selector: this.LPViewMap.retryButton, DOMEvent: 'click', callback: this.reloadChatHistory
        });
    };

    ChatHistoryWidget.prototype.createChatHistoryTable = function () {
        if (!this.chatHistoryItemsTable) {
            this.chatHistoryItemsTable = new TableViewController({
                modelController: this.modelController,
                ControllerName: 'TableViewController(ChatHistoryWidget)',
                onResize: this.onResize,
                sectionTemplateFile: 'LP_history_item.html',
                rowTemplateFile: 'LP_history_item_row.html',
                modelPath: this.chatHistoryDataPath,
                dataRenderer: this.chatHistoryDataRenderer,
                dataBinder: this.chatHistoryDataBinder,
                rowsPlaceholder: this.LPViewMap.rowsPlaceholder,
                supportKeysNavigation: true,
                context: this
            });
            this.addViewController({
                viewController: this.chatHistoryItemsTable,
                target: this.LPViewMap.historyItemsContainer
            });
        }
    };

    ChatHistoryWidget.prototype.showErrorState = function (errorMsg) {
        this.removeClass(this.LPViewMap.mainContainer, [this.LPClassesMap.loading, this.LPClassesMap.error]);
        var errorElement = this.getFirstElement(this.LPViewMap.errorMessage);
        if (errorElement) {
            errorElement.innerHTML = errorMsg;
        }
        this.addClass(this.LPViewMap.mainContainer, this.LPClassesMap.error);
        this.clearLoadingTimeout();
    };

    ChatHistoryWidget.prototype.showPastEngagementsState = function (data) {
        var numOfRecords = 0;
        if (data.newValue.chatHistoryRecord) {
            numOfRecords = data.newValue.chatHistoryRecord.length;
        } else if (typeof data.newValue.itemsCount !== "undefined") {
            numOfRecords = data.newValue.itemsCount;
        }
        this.getFirstElement(this.LPViewMap.pastEngagementsNo).innerHTML = numOfRecords;
        this.getFirstElement(this.LPViewMap.pastEngagementTitleText).innerHTML = this.translate('past_engagements');
    };

    ChatHistoryWidget.prototype.handleVisitSessionKeyChanged = function () {
        this.getWidgetData();
    };

    ChatHistoryWidget.prototype.handleParticipantTag = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.colorTag) {
            this.removeClass(this.LPViewMap.mainContainer, this.colorTag);
        }
        this.colorTag = data.newValue;
        this.addClass(this.LPViewMap.mainContainer, this.colorTag);
    };

    ChatHistoryWidget.prototype.chatHistoryDataBinder = {
        rowSelected: function (data) {

        },
        rowClicked: function (data) {
            if (!data.isSection) {
                return;
            }

            var historyItemTitle = this.getFirstElement(this.LPViewMap.historyItem, data.view);

            if (data.expanded) {
                this.addClass(historyItemTitle, this.LPClassesMap.opened);
            } else {
                this.removeClass(historyItemTitle, this.LPClassesMap.opened);
            }
        },
        rowHovered: function (data) {
        },
        modelDataChanged: function (data) {
        },
        sectionInitialized: function (data) {
            var cSatValue = data && data.rowData && data.rowData.data && +data.rowData.data.csatRate;
            if (!cSatValue) {
                this.lpHide(this.getFirstElement(this.LPViewMap.cSatItemPlaceholder, data.view));
            }
        },
        rowInitialized: function (data) {
            this.onRowInitialized(data);
        }
    };

    ChatHistoryWidget.prototype.onRowInitialized = function (data) {
        var rowDataContainer = this.getFirstElement(this.LPViewMap.rowDataContainer, data.view);

        var isAsyncMessaging = lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.visitorId);
        var transcriptVC;
        var visitorInfoVC;

        var conversationId = null;
        var isPartial = data && data.rowData && data.rowData.info && data.rowData.data.isPartial;

        if(isAsyncMessaging) {
            conversationId = data && data.rowData && data.rowData.data && data.rowData.data.conversationId;
        } else if(data && data.rowData && data.rowData.info){
            conversationId = WebAgentUtils.extractRtEngagementId(data.rowData.info.engagementId, data.rowData.info.engagementSequence);
        }

        if (isPartial && conversationId) {
            this.addClass(rowDataContainer, this.LPClassesMap.loading);

            this.modelController.populateChatHistoryConversation({
                    chatId: conversationId,
                    visitorId: this.visitorId,
                    latestAgentId: data.rowData.info.latestAgentId,
                    done: onAsyncConversationLoaded.bind(this, rowDataContainer),
                    error: onAsyncConversationError.bind(this, rowDataContainer)
                }
            );

        } else {
            transcriptVC = createTranscriptArea(this, data);
        }

        if (isAsyncMessaging) {

            var hasVisitorInfoData = data && data.rowData && data && data.rowData.info;
            if (hasVisitorInfoData) {
                var skill = lpTag.WebAgent.logicController.getSkillName(data.rowData.data.skillId);
                if (skill) {
                    data.rowData.info.skill = skill;
                }
            }

        }

        visitorInfoVC = createVisitorInfoArea(this, data);
        bindTogglingActions(this);

        function onAsyncConversationLoaded(historyItemContainer) {
            populateTranscript.call(this ,historyItemContainer);
        }

        function onAsyncConversationError(historyItemContainer) {
            //fallback to partial transcript
            populateTranscript.call(this, historyItemContainer);
        }

        function populateTranscript(historyItemContainer) {var containerSelector = [this.LPViewMap.historyItem, this.LPClassesMap.opened].join('.');
            var isContainerOpen = $(historyItemContainer).parents(containerSelector).length === 1;
            if (isContainerOpen) {
                transcriptVC = createTranscriptArea(this, data);
            }
            this.removeClass(rowDataContainer, this.LPClassesMap.loading);
        }

        function bindTogglingActions(context) {
            context.bindViewEvent({
                selector: context.LPViewMap.visitorInfoButton,
                inView: data.view,
                callback: showVisitorInfo,
                DOMEvent: 'click'
            });
            context.bindViewEvent({
                selector: context.LPViewMap.transcriptButton,
                inView: data.view,
                callback: showTranscriptInfo,
                DOMEvent: 'click'
            });
        }

        function showVisitorInfo() {
            if (transcriptVC.visible) {
                transcriptVC.lpHide();
                visitorInfoVC.lpShow();
                var transcriptElement = this.getFirstElement(this.LPViewMap.transcriptButton, data.view);
                var visitorInfoElement = this.getFirstElement(this.LPViewMap.visitorInfoButton, data.view);


                this.removeClass(transcriptElement, this.LPClassesMap.opened);
                this.addClass(visitorInfoElement, this.LPClassesMap.opened);
            }
        }

        function showTranscriptInfo() {
            if (visitorInfoVC.visible) {
                transcriptVC.lpShow();
                visitorInfoVC.lpHide();
                var visitorInfoElement = this.getFirstElement(this.LPViewMap.visitorInfoButton, data.view);
                var transcriptElement = this.getFirstElement(this.LPViewMap.transcriptButton, data.view);

                this.removeClass(visitorInfoElement, this.LPClassesMap.opened);
                this.addClass(transcriptElement, this.LPClassesMap.opened);
            }
        }

        function createTranscriptArea(context, data) {
            data = data || {};
            var rowData = data.rowData || {};
            var rowDataInfo = rowData.info || {};
            var rowDataMetaData = rowData.data || {};
            //add chat duration
            var value = {chatDurationText: '', chatDuration: '', rowData: rowData};
            if (!isAsyncMessaging) {
                value.chatDuration = lpTag.WebAgent.logicController.getFormatDurationTime(rowDataInfo.duration).text;
            }

            value.chatDurationText = context.translate('LEWebAgent.chatDurationText');

            var transcriptVC = new ChatViewController({
                modelController: context.modelController,
                visitorId: context.visitorId,
                templateFile: 'LP_chat_transcript.html',
                textInjection: value,
                asyncMessaging: isAsyncMessaging,
                chatId: rowDataMetaData.conversationId,
                note: rowDataMetaData.note,
                onInitialize: onTranscriptInitialized,
                isHistory: true
            });
            var rowDataContainer = context.getFirstElement(context.LPViewMap.rowDataContainer, data.view);

            context.addViewController({viewController: transcriptVC, target: rowDataContainer});
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(context.visitorId);
            var tag = context.modelController.getModelParam(participantPath + '.participantTag');
            transcriptVC.participantTagChanged({newValue: tag});

            if (isAsyncMessaging) {
                context.bindModel({
                    modelPath: 'chats.' + rowDataMetaData.conversationId + '.chatInfo.agentNote',
                    callback: onConversationNoteChanged
                });
                transcriptVC.updateAgentSummary(rowDataMetaData.note);
            }

            return transcriptVC;
        }

        function onTranscriptInitialized() {
            if (data.rowData.transcript && data.rowData.transcript.line) {
                transcriptVC.handleChatLines({newValue: data.rowData.transcript.line});
            }
        }

        function onConversationNoteChanged(data) {
            data = data || {};
            transcriptVC.updateAgentSummary(data.newValue);
        }

        function createVisitorInfoArea(context, data) {
            visitorInfoVC = new VisitorInfoViewController({
                visitorId: context.visitorId,
                modelController: context.modelController,
                templateFile: 'LP_visitor_info_table.html',
                onInitialize: onVisitorInfoInitialized
            });
            var rowDataContainer = context.getFirstElement(context.LPViewMap.rowDataContainer, data.view);
            context.addViewController({viewController: visitorInfoVC, target: rowDataContainer, hidden: true});

            if (isAsyncMessaging) {
                var visitorInfoElement = context.getFirstElement(context.LPViewMap.visitorInfoButton, data.view);
                visitorInfoElement.innerHTML = context.translate('conversationInfo');
            }

            return visitorInfoVC;
        }

        function onVisitorInfoInitialized() {
            var array = [];
            for (var prop in data.rowData.info) {
                if (data.rowData.info.hasOwnProperty(prop)) {
                    var finalValue = data.rowData.info[prop];
                    if (prop === 'startTime' || prop === 'endTime') { // TODO: Make those static in the beginning of the class
                        if (finalValue) {
                        if (isNaN(finalValue)) {
                            finalValue = lpUtils.createDate(finalValue, lpUtils.FORMAT_TYPES.CHAT_HISTORY);
                        }
                        finalValue = lpUtils.formatDateAsString(finalValue);
                    }
                    else if (data.rowData.transcript && data.rowData.transcript.line && data.rowData.transcript.line.length) {
                        var timeLine = prop === 'startTime' ? _.first(data.rowData.transcript.line) : _.last(data.rowData.transcript.line);
                        var timeStamp = (timeLine && timeLine.time) || (timeLine && timeLine.serverTimeStamp);
                        if (timeStamp) {
                            finalValue = lpUtils.formatDateAsString(lpUtils.createDate(timeStamp, lpUtils.FORMAT_TYPES.CHAT_HISTORY));
                        }
                        else {
                            finalValue = this.translate('notAvailable');
                        }
                    }
                    else {
                        finalValue = this.translate('notAvailable');
                    }
                    }
                    else if (prop === 'duration') {
                        finalValue = lpTag.WebAgent.logicController.getFormatDurationTime(finalValue).text;
                    } else if (prop === 'agentName'){
                        var agentDeleted = data.rowData.info.agentDeleted;
                        finalValue = agentDeleted ? finalValue + ' ' + this.translate('agent_deleted_indication') : finalValue;
                    }
                    array.push({displayName: prop, value: finalValue});
                }
            }
            if (data.rowData.customVariables && data.rowData.customVariables.customVariable) {
                var customVariablesArray = data.rowData.customVariables.customVariable;
                for (var i = 0; i < customVariablesArray.length; i++) {
                    if (typeof customVariablesArray[i].value !== "undefined" && customVariablesArray[i].value !== "") {
                        array.push(customVariablesArray[i]);
                    }
                }
            }
            if (visitorInfoVC) {
                visitorInfoVC.customVariablesTable.modelData = array;
                visitorInfoVC.customVariablesTable.modelChanged();
                if (data.rowData.navigation) {
                    visitorInfoVC.addNavigationHistoryInfoItems(data.rowData.navigation.page);
                    visitorInfoVC.render();
                }
            }
        }
    };

    ChatHistoryWidget.prototype.chatHistoryDataRenderer = {
        numberOfSections: function (data) {
            return data.length;
        },

        numberOfRowsInSection: function (data) {
            return 1;
        },

        dataForSection: function (data, sectionIndex) {
            var rowData = data[sectionIndex];
            var value;
            value = {
                agentName: '',
                chatDuration: '',
                resolved: '',
                resolvedTooltip: '',
                rowData: rowData
            };
            var name = this.translate('notAvailable');
            if (rowData.customVariables) {
                for (var i = 0; i < rowData.customVariables.customVariable.length; i++) {
                    if (rowData.customVariables.customVariable[i].name === 'identifier') {
                        name = rowData.customVariables.customVariable[i].value;
                        break;
                    }
                }
            }

            if (rowData.data && rowData.data.agentName) {
                name = rowData.data.agentName;
            } else if (rowData.info && rowData.info.agentName) {
                name = rowData.info.agentName;
            } else if (rowData.transcript) {
                name = this.getAgentName(rowData.transcript);
            }

        if (rowData.info && rowData.info.startTime) {
            value.historyRecordTimestamp = lpUtils.formatDateAsString(lpUtils.createDate(rowData.info.startTime, lpUtils.FORMAT_TYPES.CHAT_HISTORY));
        }
        else if (rowData.transcript && rowData.transcript.line && rowData.transcript.line[0] && (rowData.transcript.line[0].time || rowData.transcript.line[0].serverTimeStamp)) {
            var time = rowData.transcript.line[0].time || rowData.transcript.line[0].serverTimeStamp;
            value.historyRecordTimestamp = lpUtils.formatDateAsString(lpUtils.createDate(time, lpUtils.FORMAT_TYPES.CHAT_HISTORY));
        }
        else {
            value.historyRecordTimestamp = this.translate('notAvailable');
        }
        value.agentName = name;

        if (rowData && (rowData.info.agentDeleted || rowData.data.agentDeleted)){
            value.agentDeleted = ' ' + this.translate('agent_deleted_indication');
        } else {
            value.agentDeleted = '';
        }

        var csatEnabled = lpTag.WebAgent.logicController.isCsatViewEnabled();
        value.cssClassName = !csatEnabled ? 'hide' : '';
        if (rowData.data) {
            value.csatRate = rowData.data.csatRate;
            if (typeof rowData.data.isConversationResolved === 'boolean') {
                value.resolved = rowData.data.isConversationResolved + '';
                if (csatEnabled) {
                    value.cssClassName += 'add_separator';
                }
                value.resolvedTooltip = this.translate('isConversationResolvedTooltip_' + value.resolved);
            }
        }

            return value;
        },
        dataForRowInSection: function (data, rowIndex, secIndex) {
            var rowData = data[secIndex];
            var value;
            value = {visitorName: '', chatDuration: '', rowData: rowData};
            value.chatDuration = lpTag.WebAgent.logicController.getFormatDurationTime(rowData.info.duration).text;

            return value;
        }
    };

    ChatHistoryWidget.prototype.getAgentName = function (engagementObject) {
        var agentName = this.translate('notAvailable');
        for (var i = 0; i < engagementObject.line.length; i++) {
            var chatLine = engagementObject.line[engagementObject.line.length - i - 1];
            if (chatLine.source === "agent") {
                agentName = chatLine.by;
                break;
            }
        }
        return agentName;
    };

    ChatHistoryWidget.prototype.handleChatHistory = function (data) {
        if (typeof data.newValue === 'undefined') {
            return;
        }
        if (data.newValue.status && data.newValue.status === "fetching") { // Identifying the Interaction History service fetching
            return;
        }
        this.clearLoadingTimeout();
        this.removeClass(this.LPViewMap.mainContainer, [this.LPClassesMap.loading, this.LPClassesMap.error]);   //remove loading/error class if exists
        if (data.newValue.error && data.newValue.error !== 'No History Records') { // Identifying the AppServer service error
            this.showErrorState(this.translate('error_chat_history_msg'));
            return;
        }
        if (data.newValue.status && data.newValue.status === "error") { // Identifying the Interaction History service error
            this.showErrorState(this.translate('error_chat_history_msg'));
            return;
        }
        this.showPastEngagementsState(data);

        if (lpTag.WebAgent.logicController.isVisitorAsyncMessaging(this.visitorId)) {
            this.setCSATStatistics();
        }
    };

    ChatHistoryWidget.prototype.setCSATStatistics = function () {
        var cSatStatisticsPath = 'engagementsHistoryByVisitor.' + this.visitorId + '.cSatStatistics';
        var cSatStatistics = this.modelController.getModelParam(cSatStatisticsPath);
        if (cSatStatistics && cSatStatistics.percentText) {
            var cSatPH = this.getFirstElement(this.LPViewMap.csatPlaceholder);

            var csatRateText = cSatStatistics ? cSatStatistics.percentText : '';
            this.getFirstElement(this.LPViewMap.cSatAverageText).innerHTML = csatRateText;

            // setting the tooltip.
            cSatPH.title = this.translateObj('engagementsHistory_CSAT_CalcInfo_tooltip', [cSatStatistics.fillCount, cSatStatistics.conversationCount]);
            this.lpShow(cSatPH);
        }
    };

    ChatHistoryWidget.prototype.reloadChatHistory = function () {
        this.setChatHistoryLoading();
        this.getWidgetData(true);
    };

    ChatHistoryWidget.prototype.handleEngagementStateChanged = function (data) {
        if (data.newValue) {
            if ((data.newValue === 'inactive' || data.newValue === 'completed')) {
                this.clearLoadingTimeout();
            }
        }
    };

    ChatHistoryWidget.prototype.clearLoadingTimeout = function () {
        if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
            this.loadingTimeout = null;
        }
    };

    ChatHistoryWidget.prototype.handleAcceptedEngagementChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.widgetsManager.focusedVisitorId === this.visitorId) {
            this.showWidget();
        }
    };

    ChatHistoryWidget.prototype.handleSpectatedEngagementChanged = function (data) {
        if (!data.newValue) {
            return;
        }
        this.showWidget();
    };

    ChatHistoryWidget.prototype.visitorDisposed = function () {
        this.clearLoadingTimeout();
        WidgetViewController.prototype.visitorDisposed.call(this);
    };

    return ChatHistoryWidget;

});
